import { useState } from 'react';

export const useQuestionnaireHook = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverText, setPopoverText] = useState('');

  const handlePopoverOpen = (event, text) => {
    setAnchorEl(event.currentTarget);
    setPopoverText(text);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const getAnswerText = (answer, options = []) => {
    if (!answer || (Array.isArray(answer) && answer.length === 0)) return 'N/A';
    
    if (Array.isArray(answer)) {
      const displayValues = answer
        .map((value) => options.find((item) => item?.id === value)?.displayValue)
        .filter(Boolean);
      
      return displayValues.length > 0 ? displayValues.join(', ') : 'N/A';
    }
    
    return options.find((option) => option?.id === answer)?.displayValue || 'N/A';
  };
  

  return {
    anchorEl,
    popoverText,
    openPopover: Boolean(anchorEl),
    handlePopoverOpen,
    handlePopoverClose,
    getAnswerText,
  };
};
